import React from 'react';
import './DeleteAccount.scss';
import DeleteAccount1 from '../../assets/DeleteAccount1.png';
import DeleteAccount2 from '../../assets/DeleteAccount2.png';
import DeleteAccount3 from '../../assets/DeleteAccount3.png';

export default function DeleteAccount() {
  return (
    <section className='delete-account-container'>
      <div className='heading-container'>
        <h1>How to Delete your MyPDF Account</h1>
        <h2>
          We’re sorry to see you go — here’s how to delete your account safely
        </h2>
        <p> Published on April 12, 2025</p>
      </div>

      <div className='first'>
        <h3 className='hanging-indent' data-step="1">
          Open MyPDF app and navigate to Home Screen then Tap the Profile Icon located in the top right corner of the screen.
        </h3>
        <div className='image-container'>
          <img src={DeleteAccount1} alt="find account icon" />
        </div>
      </div>

      <div className='second'>
        <div className='image-container'>
          <img src={DeleteAccount2} alt="find account icon" />
        </div>
        <h3 className='hanging-indent' data-step="2">
          In the profile section, scroll down through the menu then tap on the “Delete Your Account” option near the bottom of the list.
        </h3>
      </div>

      <div className='third'>
        <h3 className='hanging-indent' data-step="3">
          A Confirmation Dialog Box will appear asking if you're sure you want to delete your account. Press the Delete button to permanently remove your account.
        </h3>
        <div className='image-container'>
          <img src={DeleteAccount3} alt="find account icon" />
        </div>
      </div>
    </section>
  );
}
